import React, { useContext, useEffect, useState } from "react";
import { Container, Main } from "../Styles/Global.Styled";
import { css } from "styled-components";
import ParnterHandshake from "../assets/Images/ParnterHandshake.jpeg";
import RegisterForm from "../Forms/RegisterForm/RegisterForm";
import VerifyCodeForm from "../Forms/VerifyCodeForm/VerifyCodeForm";
import {
  addressFormData,
  companyNameProps,
  companyRegCodeProps,
  dailingCodeProps,
  emailProps,
  firstNameProps,
  lastNameProps,
  passwordProps,
  phoneNumberProps,
} from "../helpers/formProps";
import Message from "../Components/Sections/Message";
import PageHeader from "../Components/PageBanner/PageHeader";
import { AuthContext } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const contentCnt = css`
  align-self: center;
  padding: 5vh 0 10vh;
  justify-content: center;
`;

const registerFormProps = [
  firstNameProps(),
  lastNameProps(),
  dailingCodeProps(),
  phoneNumberProps(),
  emailProps(),
  { ...passwordProps(), helperTxt: true },
  companyNameProps(),
  companyRegCodeProps(),
  ...addressFormData(),
];

const Registeration = () => {
  const [formStep, setStep] = useState(0);
  const [formData, setForm] = useState(registerFormProps);
  const { isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/my-account", { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return (
    <Main>
      <PageHeader
        header={"Become our partner today"}
        img={ParnterHandshake}
        color={"white"}
      />
      <Container $baseStyle={contentCnt}>
        {formStep === 0 ? (
          <RegisterForm
            formData={formData}
            setForm={setForm}
            setStep={setStep}
          />
        ) : formStep === 1 ? (
          <VerifyCodeForm
            actionForm={() => setStep((prev) => prev + 1)}
            credentials={[formData[2].value, formData[5].value]}
          />
        ) : formStep === 2 ? (
          <Message
            type="success"
            header="Registeration complete!"
            message={
              <>
                Your account has been registered successfully.
                <br /> Thank you for joining us!
              </>
            }
          />
        ) : null}
      </Container>
    </Main>
  );
};

export default Registeration;
